import { createSelector } from 'reselect'

import { Site } from '../../common/constants/siteList'
import { IRootState } from '../../common/reducers'
import { IEnhancedLocation } from '../../common/reducers/reactRouterLocation'
import { getFeaturesConfig } from '../../common/utils/features'

export const getFeaturesConfigSelector = createSelector<
  IRootState,
  Site,
  IEnhancedLocation,
  any,
  any
>(
  [
    state => state.common.currentSite,
    state => state.router.location,
    state => state.experiments
  ],
  getFeaturesConfig
)
